import React from 'react';

// parent component must have position: relative set in css
const DisabledOverlay = () => <div className="common-ui-disabled-overlay" />;

export default DisabledOverlay;
